// removed by extract-text-webpack-plugin
module.exports = {"sapcnqr-badge":"sapcnqr-badge-402b17","sapcnqr-badge--muted":"sapcnqr-badge--muted-9a6d34"};